import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../../services/api';
import { handleApiError } from '../../services/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await apiService.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      setError(handleApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <Link to="/" aria-label="OnlyKickers home" className="inline-block mb-5">
            <span className="font-display text-2xl tracking-tight leading-none text-secondary-900">
              ONLY<span className="text-gold-700">KICKERS</span>
            </span>
          </Link>
          <h2 className="font-display uppercase text-3xl sm:text-4xl leading-none text-ink-900">
            Reset Password
          </h2>
          <p className="mt-2 text-sm text-secondary-600">
            Enter your email and we'll send you a reset link.
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="card">
          <div className="card-body">
            {submitted ? (
              <div className="text-center space-y-4">
                <div className="text-4xl">📬</div>
                <p className="text-secondary-700 text-sm leading-relaxed">
                  If an account exists for <strong>{email}</strong>, a reset link has been sent.
                  Check your inbox — it may take a minute or two to arrive.
                </p>
                <p className="text-secondary-500 text-xs">
                  The link expires in 1 hour.
                </p>
                <Link to="/login" className="block mt-4 text-sm font-medium text-primary-600 hover:text-primary-500">
                  Back to sign in
                </Link>
              </div>
            ) : (
              <form className="space-y-6" onSubmit={handleSubmit}>
                {error && (
                  <div className="alert-danger">
                    {error}
                  </div>
                )}

                <div>
                  <label htmlFor="email" className="form-label">
                    Email address
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="form-input"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError('');
                    }}
                  />
                </div>

                <div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="btn-primary w-full"
                  >
                    {loading ? (
                      <div className="flex items-center justify-center">
                        <div className="loading-spinner w-4 h-4 mr-2"></div>
                        Sending...
                      </div>
                    ) : (
                      'Send reset link'
                    )}
                  </button>
                </div>

                <div className="text-center">
                  <Link to="/login" className="text-sm font-medium text-primary-600 hover:text-primary-500">
                    Back to sign in
                  </Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
